'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createIconComponent = require('./utils/createIconComponent');

var _createIconComponent2 = _interopRequireDefault(_createIconComponent);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconEmailActionUnread = (0, _createIconComponent2.default)({ fillContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M23.888 5.832a.182.182 0 0 0-.2.039l-9.747 9.745a2.75 2.75 0 0 1-3.888 0L.31 5.871a.18.18 0 0 0-.2-.039A.182.182 0 0 0 0 6v12a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a.181.181 0 0 0-.112-.168z' }),
    _react2.default.createElement('path', { d: 'M11.115 14.556a1.252 1.252 0 0 0 1.768 0l9.686-9.686a.5.5 0 0 0 .121-.511C22.58 4.03 22.274 4 22 4H2c-.275 0-.583.03-.691.359a.5.5 0 0 0 .121.511z' })
  ), lightContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M2.5 20.454a2.503 2.503 0 0 1-2.5-2.5v-12a2.48 2.48 0 0 1 .738-1.77 2.485 2.485 0 0 1 1.762-.73h19a2.484 2.484 0 0 1 1.802.77c.447.461.698 1.078.698 1.73v12c0 1.378-1.122 2.5-2.5 2.5h-19zM1.176 5.253A1.467 1.467 0 0 0 1 5.954v12c0 .827.673 1.5 1.5 1.5h19c.827 0 1.5-.673 1.5-1.5v-12c0-.248-.06-.486-.176-.701l-10.508 8.589a.499.499 0 0 1-.632 0L1.176 5.253zM12 12.808l10.078-8.237a1.481 1.481 0 0 0-.578-.117h-19c-.2 0-.396.04-.578.117L12 12.808z' })
  ), regularContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M3 20.5a2.252 2.252 0 0 1-2.25-2.25v-12a2.22 2.22 0 0 1 .498-1.411l.023-.027A2.238 2.238 0 0 1 3 4h18a2.245 2.245 0 0 1 1.757.845l.018.026c.311.399.475.875.475 1.379v12A2.252 2.252 0 0 1 21 20.5H3zm-.75-2.25c0 .414.336.75.75.75h18a.75.75 0 0 0 .75-.75V6.562l-7.276 5.596a4.077 4.077 0 0 1-2.474.841c-.891 0-1.77-.299-2.474-.841L2.25 6.562V18.25zm8.19-7.281c.444.342.998.53 1.56.53s1.115-.188 1.559-.53l7.111-5.47H3.329l7.111 5.47z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconEmailActionUnread.displayName = 'IconEmailActionUnread';
exports.default = IconEmailActionUnread;